import { on } from '@ember/modifier';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import EditableModelPropertyComponent from 'webapp/components/editable-model-property';
import FormInputComponent from 'webapp/components/form/input';

export default class EditableH1TitleComponent extends EditableModelPropertyComponent {
	<template>
		{{#if @canEdit}}
			{{#if this.isInlineEditingActive}}
				<h1 class="editing">
					<FormInputComponent
						name={{this.name}}
						maxlength="65"
						@value={{this.newText}}
						@autofocus={{true}}
						@loseFocusOnEnter={{true}}
						@focusOut={{this.stopEditing}}
					/>
				</h1>
			{{else}}
				<h1 class="canEdit">
					<label
						{{on "click" this.startEditing}}
						class="editableTitle"
					>{{this.text}}<CommonUiIconComponent
							@name="Pencil"
							@size="xs"
							@class="edit-icon"
						/>
					</label>
				</h1>
			{{/if}}
		{{else}}
			<h1>
				{{this.text}}
			</h1>
		{{/if}}
	</template>
}
